module.exports = __webpack_public_path__ + "img/hopways-03.9a248072.webp";